const listeners = [];

export const definirItemListener = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
  listeners.forEach((cb) => cb(key, value));
};

export const obterItemLocalStorage = (key) => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};

export const subscribeListener = (callback) => {
  listeners.push(callback);
  return () => {
    const index = listeners.indexOf(callback);
    if (index > -1) listeners.splice(index, 1);
  };
};